export const environment = {
  production: false,
  pr1ApiUrl: 'https://pr1dev.przone.net/pr1core/Private',
  appKey: 'commerce engine',
  environment: 'dev',
  appMode: 'standalone',
  commentApiUrl: "https://pr1dev.przone.net/pr1commentapi/Private",
  shopifyAuth: {
    apiKey: '',
    host: '',
  },
  applicationInsights: {
    enabled: false,
    connectionString: 'InstrumentationKey=89111394-0f35-45c3-85ef-3b717c84c902;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=c7d5ed0a-425d-46d7-ac73-073a662fae8d',
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,
  },
  knockApp: {
    FEED_KEY: 'b8a11870-97b0-47a5-a95c-9dee1131200e',
    CLIENT_KEY: 'pk_test_2_pBYKuWjv9a7NC20leDBy5Cfr5p8qG-mDbb3mYGki4',
  },
  auth: {
    domain: 'dev-hn16g194.us.auth0.com',
    clientId: '2BuxUAB3s2SMOzQBOIwG04EZlxDV5cLC',
    audience: 'https://pr1-std-private-api.przone.net',
    organization: 'org_HjNjnLSP4hS3rpdV',
    redirectUri: window.location.origin + '/pr1core/',
  },
  keycloak: {
    url: 'https://auth.europe-west1.storyteq.work/',
    realm: 'Commerce-engine-Dev',
    clientId: 'TestClientWebUI',
    redirectUri: window.location.origin + '/pr1core/',
  },
  httpInterceptor: {
    allowedList: [`https://pr1dev.przone.net/pr1core/Private/*`, `https://pr1dev.przone.net/pr1commentapi/Private/*`],
  },
  blobStorage: {
    kroger: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
      helpDocPath: '/docs/kroger/KRG_Commerce_Engine_User_Guide_021826.pdf'
    },
    riteaid: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    standard: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    walgreens: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    demo: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    qaautomation: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    unfi: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    arg: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    tractorsupply: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
    schnucks: {
      assetsUrl:
        'https://pr1stddevstandardblob.blob.core.windows.net/public/assets',
    },
  },
  useAuth0: false
};
